import { Fragment, useEffect, useState, type FC } from "react";
import { TextField, Chip, Typography } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import type {
  DropdownArrPropsType,
  MultiDropDataType
} from "../../DataTypes/Form";
import CommonStyle from "Components/Style";

const MultiSelectWithChips: FC<MultiDropDataType> = (props) => {
  const {
    id,
    label,
    placeholder,
    error,
    errorText,
    required,
    readOnly,
    dropArr,
    onClick,
    width,
    dropValue
  } = props;
  const viewOnly = readOnly;
  const newDropVals = dropValue || [];
  const newDropArr = dropArr || [];
  const [localDropVals, setLocalDropVals] =
    useState<DropdownArrPropsType[]>([]);

  useEffect(() => {
    handleDropVals();
  }, [newDropVals]);

  const handleDropVals: () => void = () => {
    const newArr: DropdownArrPropsType[] = [];
    newDropVals.forEach(dropValEl => {
      const findEl = newDropArr.find(dropArrEl => dropValEl == dropArrEl.value);
      if (findEl) newArr.push(findEl);
    })
    setLocalDropVals(newArr);
  }

  const handleOnChange: (
    dropVal: DropdownArrPropsType[]
  ) => void = (dropVal) => {
    onClick && onClick(dropVal.map(el => el.value));
  };

  return (
    <Fragment>
      {label && (
        <Typography variant="subtitle1"
          sx={{
            mt: 0.5,
            "&>span": {
              color: "error.main",
            },
          }}>
          {label} {required ? <span>*</span> : ""}
        </Typography>
      )}
      <Autocomplete
        id={id}
        readOnly={viewOnly}
        disablePortal
        clearIcon={false}
        fullWidth
        sx={{
          ...sxDropBox,
          width
        }}
        multiple
        limitTags={1}
        options={newDropArr}
        value={localDropVals}
        isOptionEqualToValue={(option, value) => option.value == value.value}
        onChange={(event, changeVal) => {
          const newVal: DropdownArrPropsType[] =
            JSON.parse(JSON.stringify(changeVal));
          handleOnChange(newVal)
        }}
        slotProps={{
          popper: {
            sx: {
              "& .MuiAutocomplete-listbox": {
                maxHeight: "200px", // Set your custom height here
                fontSize: "0.85rem"
              },
            },
          },
        }}
        renderTags={(tagValue, getTagProps) => {
          const displayed = tagValue.slice(0, 1); // show only first chip
          const hiddenCount = tagValue?.length - 1;
          return displayed.map((option, index) => {
            return (
              <Chip
                variant="outlined"
                label={
                  hiddenCount > 0
                    ? `${option.label} +${hiddenCount} more`
                    : option.label
                }
                {...getTagProps({ index })}
                sx={{ m: "0px !important", height: 30 }}
                key={option.id}
              />
            )
          })
        }}
        renderInput={(params) => (
          <TextField
            placeholder={placeholder}
            error={error ? error : false}
            {...params}
            sx={{
              ...(readOnly ? { ...sxReadOnly } : { ...CommonStyle.sxWhiteBox }),
              "&>div": {
                p: "0px !important",
                fontSize: "0.85rem",
                "& >div": {
                  right: "0px !important",
                  position: "unset",
                },
                "& >input": {
                  px: 0.5,
                  py: 1,
                },
                "& >fieldset": {
                  borderWidth: 0,
                },
              },
            }}
          />
        )}
      />
      {
        error && (
          <Typography variant="subtitle2" color="red">
            {errorText}
          </Typography>
        )
      }
    </Fragment>
  );
};

export default MultiSelectWithChips;

const sxDropBox = {
  p: "0px !important",
  fontSize: "0.85rem"
}

const sxReadOnly = {
  backgroundColor: "custom.grey",
  boxShadow: "0px 0px 6px #00000029",
  borderRadius: 1.25,
  " >fieldset": {
    display: "none",
  },
};